<template>
  <div class="irp-contacts-tab" data-testid="irp-contacts-tab">Contacts</div>
</template>
